const C = {
  name: "Wallet",
  dimensions: { width: 22, height: 18 },
  content: `
    <svg fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15 9C15 9.55228 14.5523 10 14 10C13.4477 10 13 9.55228 13 9C13 8.44771 13.4477 8 14 8C14.5523 8 15 8.44771 15 9Z" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M20 15V13.8282C21.1632 13.4148 22 12.3019 22 11V7C22 5.69806 21.1632 4.58522 20 4.17183V3C20 1.44943 18.8388 0 17.2 0H2.8C1.16122 0 0 1.44943 0 3V15C0 16.5506 1.16122 18 2.8 18H17.2C18.8388 18 20 16.5506 20 15ZM2.8 2C2.45878 2 2 2.35057 2 3V15C2 15.6494 2.45878 16 2.8 16H17.2C17.5412 16 18 15.6494 18 15V14H14C11.2377 14 9 11.7623 9 9C9 6.23772 11.2377 4 14 4H18V3C18 2.35057 17.5412 2 17.2 2H2.8ZM14 6C12.3423 6 11 7.34228 11 9C11 10.6577 12.3423 12 14 12H19C19.5477 12 20 11.5477 20 11V7C20 6.45228 19.5477 6 19 6H14Z" />
    </svg>
  `
};
export {
  C as Wallet
};
